import React from "react";
import { Languages } from "lucide-react";
import { useI18n } from "../i18n";
import { cn } from "../lib/utils";

/** Compact HR / EN switcher. */
export const LanguageSwitcher = ({ className, showIcon = true }) => {
  const { lang, setLang, languages } = useI18n();
  return (
    <div
      className={cn("inline-flex items-center gap-1 rounded-lg border bg-card p-0.5", className)}
      data-testid="language-switcher"
    >
      {showIcon ? <Languages className="ml-1.5 h-3.5 w-3.5 text-muted-foreground" /> : null}
      {languages.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => setLang(l.code)}
          aria-pressed={lang === l.code}
          title={l.label}
          data-testid={`lang-${l.code}`}
          className={cn(
            "rounded-md px-2 py-1 text-xs font-semibold transition-colors",
            lang === l.code
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:bg-accent"
          )}
        >
          {l.short}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
